import React, { useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createColumnHelper } from "@tanstack/react-table";

import AccountDetailsCard from "./card/accountDetailsCard";
import { ReactComponent as InvoiceIcon } from "../../images/invoice.svg";
import Table from "../../ui-components/table/table";
import Tag from "../../ui-components/molecules/tag/tag";
import { TagColor } from "../../app/data/common/tagColor";
import NumberFormat from "react-number-format";
// import XGSNavLink from "../../ui-components/xgs-nav-link/xgsNavLink";

import { accountDetailsSelector, getAccountDetailsInvoices } from "../../slices/account-details/accountDetailsSlice";
import useWindowSize from "../../hooks/useWindowsSize";
import ShipmentModel from "../../app/data/tracking/ShipmentModel";

const columnHelper = createColumnHelper<ShipmentModel>();

const AccountDetailsInvoices: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const accountDetailsState = useSelector(accountDetailsSelector);
  const tableRef = useRef<HTMLDivElement>(null);
  const windowWidth = useWindowSize()[0];

  const getStatusColor = (paid: boolean) => (paid ? TagColor.GREEN : TagColor.ORANGE);
  
  const columns = [
    columnHelper.accessor("invoice.invoiceNumber", {      
      header: "Invoice #",
      size: 150,
    }),
    columnHelper.accessor("invoice.dateInvoice", {
      header: "Invoice Date",
      cell: (cellProps) => (
        <>
          {cellProps.getValue()? cellProps.getValue().toUiDateFormat() : "-"}
        </>
      ),
      size: 292,      
    }),
    columnHelper.accessor("invoice.invoiceAmount", {
      header: "Amount",
      cell: (cellProps) => (
        <div className="xgs-table__cell-amount">
          <span>$</span>
          <span className="xgs-table__cell-amount__value">
            <NumberFormat
              value={cellProps.getValue()}
              decimalScale={2}
              displayType={"text"}
              fixedDecimalScale={true}
              thousandSeparator={true}
            />
          </span>
        </div>
      ),    
      size: 292,
    }),
    // columnHelper.accessor("invoice.dateDue", {      
    //   header: "Due Date",
    //   cell: (cellProps) => (
    //     <>
    //       {cellProps.getValue()?.toUiDateFormat()}
    //     </>
    //   ),    
    //   size: 292,
    // }),
    columnHelper.accessor("invoice.paid", {
      header: "Paid",
      cell: (cellProps) => (        
          <Tag mods={{ color: getStatusColor(cellProps.getValue()), uppercase: true }}>
            {cellProps.getValue() ? "paid" : "due"}
          </Tag>        
      ),   
      size: 88,
    }),    
  ];

  const onInfiniteScroll = () => {
    if (!accountDetailsState.companyInfo?.accountId) return;

    dispatch(getAccountDetailsInvoices(parseInt(accountDetailsState.companyInfo?.accountId), accountDetailsState.requestScroll["GET_INVOICES"]?.lastIds, accountDetailsState.requestScroll["GET_INVOICES"]?.page));
  }

  //eslint-disable-next-line
  const contentWidth = useMemo(() => (tableRef.current && tableRef.current?.offsetWidth), [windowWidth]);

  return (
    <AccountDetailsCard
      mix="account-details__invoices"
      scrollable={true}
      contentWidth={contentWidth}
      title="Last Invoices"
      icon={<InvoiceIcon />}
      // link={<XGSNavLink
      //   className="blue-link"
      //   target="_blank"
      //   to={`/invoices?account=${accountDetailsState.companyInfo?.accountName}`}
      //   onClick={(e) => e.stopPropagation()}
      // >
      //   See Details
      // </XGSNavLink>}
    >
      <div className="account-details__table-wrapper">
        <Table
          autoHeight={true}
          ref={tableRef}
          isLoading={accountDetailsState.request["GET_INVOICES"]?.requestStarted}
          columns={columns}
          data={accountDetailsState.invoices}
          cursorPointer={true}
          rowHeight={56}
          minTableHeight={280}
          responsive={true}
          infiniteScroll={true}
          infiniteScrollLoading={accountDetailsState.request["GET_INVOICES_PORTION"]?.requestStarted}
          infiniteScrollHasNext={!accountDetailsState.requestScroll["GET_INVOICES"]?.loadedAll}
          onInfiniteScroll={onInfiniteScroll}
        />
      </div>
    </AccountDetailsCard>
  );
};

export default AccountDetailsInvoices;